import React, { useEffect, useCallback, useRef } from "react";
import { Link, useLocation } from "react-router-dom";

const NavSecondary = ({ airplanes, manufacture, ...props }) => {
	const element = useRef();
	const path = useLocation().pathname;
	const body = document.querySelector("body");
	const handleScroll = useCallback(() => {
		if (window.scrollY > 70) {
			element.current.style.position = "fixed";
			element.current.style.top = "0";
			return;
		}

		element.current.style.position = "absolute";
		element.current.style.top = "70px";
	}, []);

	useEffect(() => {
		if (path !== "/" && path !== "/samoloty" && manufacture != null && window.innerWidth >= 1080) {
			body.style.paddingTop = `${element.current.clientHeight + 70}px`;
		} else {
			body.style.paddingTop = "70px";
		}

		if (manufacture == null || manufacture === "null" || window.innerWidth < 1080) return;
		window.addEventListener("scroll", handleScroll);
		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, [manufacture, handleScroll, path, body.style]);

	if (manufacture == null || manufacture === "null") return <></>;
	return (
		<nav className="nav nav--secondary" ref={element}>
			{airplanes[manufacture].map((v, i) => {
				const key = v.toLowerCase().replace(/\s/g, "");

				if (manufacture === "boeing") v = "Boeing " + v;
				return (
					<div className="nav__item" key={key}>
						<Link to={`/samoloty/${key}`} replace>
							{v}
						</Link>
					</div>
				);
			})}
		</nav>
	);
};

export default NavSecondary;
